import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserStore } from '../stores/user.store';

export const userGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (!userStore.isAuthenticated()) {
    router.navigate(['/auth/login']);
    return false;
  }

  if (userStore.isNormalUser()) {
    return true;
  }

  if (userStore.isAdmin()) {
    router.navigate(['/admin/dashboard']);
    return false;
  }

  router.navigate(['/auth/login']);
  return false;
};
